import React from 'react';
import { connect } from 'react-redux';
import { compose, is } from 'ramda';
import { Map } from 'immutable';

import styleFile from './Cancelation.js';
import RichText from '@synergycms_core/components/generic/RichText';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import actions from '../../store/actions';
import Form from '@synergycms_core/components/generic/Form';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import { getPenalties, getPenaltyTimezone, getPenaltyChargebackUSA } from '../../utils/penalties';
import { shouldShowTaxes, splitMandatoryFees } from '../../utils';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import moment from 'moment';
import Price from '@synergycms_core/components/generic/Price';
import { Loading, LoadingBook } from '@synergycms_core/components/functional/Loading';
import { PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import Footer from '../../components/functional/Footer/Footer';
import { isUsDomain } from 'synergycms_core/src/utils/utils.js';
import { parseTaxes } from '../../utils';

export const LoadingCancellation = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos cancelando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export const LoadingReservation = () => (
  <React.Fragment>
    <LoadingBook
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos buscando tu reserva. Este proceso puede tardar unos segundos.%_',
        translate: true
      }}
    />
  </React.Fragment>
);
/**
 *
 * @param penalties
 * @param checkinDate
 * @param rates
 * @param discounts
 * @returns {boolean|*}
 */
const isNotCancellable = (penalties, checkinDate, rates, discounts) => {
  let flexibleDiscount = discounts.find((discount) => discount.get('flexible', false) && discount.get('flexible_release', 0) > 0);
  if (!flexibleDiscount) {
    flexibleDiscount = rates.find((rate) => rate.get('flexible', false) && rate.get('flexible_release', 0) > 0);
  }
  const releaseDay = flexibleDiscount && moment(checkinDate).subtract(flexibleDiscount.get('flexible_release'), 'd');
  // const now = moment();
  // const nowHoras = now.hours();
  // const nowMinutos = now.minutes();
  // const nowMinutosEnHoraDecimal = nowMinutos / 60;
  // const nowHoraDecimal = nowHoras + nowMinutosEnHoraDecimal;
  // if(penalties && penalties[0].penalty.has("same_day")){
  //   const same_day = penalties[0].penalty.get("same_day");
  //   /**
  //    * Se utiliza local para que utilice la zona horaria local y no la UTC ya que this.checkinAnticipation
  //    * que es con la que lo vamos a comparar está calculado en la zona horaria CET
  //    * */
  //   let time = moment(penalties[0].release);
  //   const horas = time.hours();
  //   const minutos = time.minutes();
  //   const minutosEnHoraDecimal = minutos / 60;
  //   const horaDecimal = horas + minutosEnHoraDecimal;

  //   if (same_day === "LAST_DAY") {
  //     // Para LAST_DAY, la penalización se calcula con base en las horas antes del check-in.
  //     return (24 - horaDecimal) >= nowHoraDecimal;
  //   } else if (same_day === "SAME_DAY") {
  //       // Para SAME_DAY, se evalúa si la anticipación es menor o igual a la hora de penalización.
  //       return nowHoraDecimal < 0 || nowHoraDecimal * -1 > horaDecimal;
  //   }
  // }

  return (!flexibleDiscount || releaseDay.isBefore(moment())) &&
    (
      !penalties ||
      penalties.some(penalty => penalty.nr)
    );
};

class Cancelation extends React.Component {
  static displayName = 'Cancelation';

  constructor(props) {
    super(props);
    this.state = {
      cancelationSuccess: false,
      cancelationError: false
    };
  }

  cancelReservation = () => {
    return this.props.config
      .cancelReservation()
      .then(reservation => {
        this.setState(state => {
          if (reservation.get('status') === 'cancelled') {
            this.props.config.triggerEvent();
            return { cancelationSuccess: true };
          } else {
            return { cancelationError: true };
          }
        });
      })
      .catch(() => {
        this.setState({ cancelationError: true });
      });
  };

  render() {
    const { reservation, penalties, hotel, summaryPriceBreakdown } = this.props.config;
    const rates = reservation ? reservation.get('rates', Map()) : Map();
    const discounts = reservation ? reservation.get('rates', Map()) : Map();
    const checkinDate = reservation && reservation.get('checkin', false);
    const status = reservation.get('status', null);
    const showTaxes = shouldShowTaxes(hotel, reservation) ?? true;
    const taxes = parseTaxes(hotel, reservation);
    // GLOSARIO.md FCL-003 - con summaryPriceBreakdown siempre se muestra "importe total": el importe
    // mostrado pasa a ser total_price + todos los tax_amount (included y nonIncluded), no total_price_tax
    // (que solo cuenta el rate tax), para que ese importe refleje de verdad el total con todos los fees.
    const showImporteTotal = summaryPriceBreakdown || (showTaxes && !(isUsDomain() && taxes.nonIncluded.length > 0));
    const totalTaxesAmount = [...taxes.included, ...taxes.nonIncluded].reduce((sum, tax) => sum + tax.tax_amount, 0);

    const { classes } = this.props.theme.styles;
    if (!reservation) {
      return null;
    } else if (this.state.cancelationSuccess) {
      return (
        <div className={classes.cancelationContainer}>
          <RichText
            translate={true}
            text={'_%ha anulado correctamente su Reserva en%_'}
            innerStyle={[classes.mainTitle, 'mainColor']}
            ucFirst={true}
          />
          <div className={[classes.paddedText, classes.cancelledId].join(' ')}>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%localizador de la reserva%_'}
              innerStyle={[classes.goldInfo, 'mainColor', 'bold']}
            />
            :
            <RichText translate={true} text={reservation.get('tracking_id')} innerStyle={classes.reservationInfo}/>
          </div>
          <Footer />
        </div>
      );
    } else if (
      reservation.get('success') === false ||
      (status === 'cancelled' || status === 'temporary' || status === 'no_show') ||
      this.state.cancelationError ||
      isNotCancellable(penalties, checkinDate, rates, discounts)
    ) {
      return (
        <div className={classes.cancelationContainer}>
          <div>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%anulación denegada%_'}
              innerStyle={[classes.mainTitle, 'mainColor']}
            />
          </div>
          <div className={classes.paddedText}>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%ha ocurrido un problema al intentar anular esta reserva.%_'}
            />
          </div>
          <div className={classes.paddedText}>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%posiblemente ya está eliminada o su política de cancelación no permite hacerlo.%_'}
            />
          </div>
          <Footer />
        </div>
      );
    } else if (reservation.get('status', null) === 'confirmed') {
      return (
        <div className={classes.cancelationContainer}>
          <Form
            loadingTemplate={LoadingCancellation}
            onSubmit={this.cancelReservation}
            innerStyle={classes.customerForm}
            preventCallback={false}>
            <div>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%no has cancelado aún tu reserva%_'}
                innerStyle={[classes.mainTitle, 'mainColor']}
              />
            </div>
            <div className={classes.paddedText}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%a continuación te mostramos información de la reserva que nos has indicado%_'}
              />
              :
            </div>
            <div className={[classes.paddedText, classes.specialInfo].join(' ')}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%localizador de la reserva%_'}
                innerStyle={[classes.goldInfo, 'mainColor', 'bold']}
              />
              {' :'}
              <RichText translate={true} text={reservation.get('tracking_id')} innerStyle={classes.reservationInfo}/>
            </div>
            <div className={[classes.paddedText, classes.specialInfo].join(' ')}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%fecha de la reserva%_'}
                innerStyle={[classes.goldInfo, 'mainColor', 'bold']}
              />
              {' :'}
              <RichText
                translate={true}
                ucFirst={true}
                text={moment(reservation.get('booking_date')).format(isUsDomain() ? 'dddd, MMMM D, YYYY HH:mm' : 'LLLL')}
                innerStyle={classes.reservationInfo}
              />
            </div>
            <div className={classes.paddedText}>
              <RichText
                translate={true}
                ucFirst={true}
                text={showImporteTotal ? '_%importe total%_' : '_%importe subtotal%_'}
                innerStyle={[classes.goldInfo, 'mainColor', 'bold']}
              />
              {' :'}
              {hotel && (
                <Price
                  amount={
                    summaryPriceBreakdown
                      ? reservation.get('total_price') + totalTaxesAmount
                      : (showTaxes || summaryPriceBreakdown ? reservation.get('total_price_tax') : reservation.get('total_price'))
                  }
                  innerStyle={classes.reservationInfo}
                />
              )}
            </div>
            <div className={[classes.paddedText, classes.conditions, classes.separator].join(' ')}>
              <div className={classes.conditions}>
                <RichText translate={true} ucFirst={true} text={'_%condiciones%_'}/>:
              </div>
              {penalties.map((penalty, idx) => (
                <div key={idx}>
                  <RichText
                    translate={true}
                    text={penalty.text}
                    withVars={penalty}
                    ucFirst={true}
                    dangerouslySetInnerHTML={true}
                  />
                </div>
              ))}
            </div>
            <div className={[classes.paddedText, classes.conditions].join(' ')}>
              <RichText
                translate={true}
                ucFirst={true}
                text={
                  '_%a continuación te mostramos una casilla para la aceptación de la eliminación de la reserva. Si la marcas y pulsas sobre el botón confirmar eliminación, la reserva se eliminará y no se prodrá recuperar.%_'
                }
              />
            </div>
            <div className={[classes.paddedText, classes.conditions].join(' ')}>
              <RichText
                translate={true}
                ucFirst={true}
                text={
                  '_%si no desea eliminar esta reserva, cierre el navegador, la pestaña, o navegue hacia otra página.%_'
                }
              />
            </div>

            <div className={[classes.paddedText, classes.checkBoxContainer].join(' ')}>
              <label className={classes.checkBox}>
                <CheckboxField
                  defaultValue={false}
                  type={'checkbox'}
                  model={'verifyCancel'}
                  validations={['required']}
                  innerStyle={['inputCheck', classes.inputCheck]}
                />
                <RichText
                  translate={true}
                  ucFirst={true}
                  text={
                    '_%marca esta casilla para confirmar que realmente deseas eliminar definitivamente esta reserva%_'
                  }
                  innerStyle={classes.checkBoxText}
                />
              </label>
              <div className={classes.finalPrice}>
                <ButtonSubmit
                  disableOnError={true}
                  richText={{
                    text: '_%confirmar cancelación%_',
                    translate: true,
                    ucFirst: true,
                    innerStyle: ['toggleSecondButton']
                  }}
                  innerStyle={['toggleSecondButton', classes.cancelationButton]}
                />
              </div>
            </div>
          </Form>
          <Footer />
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    cancelReservation: () => {
      return dispatch(actions.customer.reservation.patchAsync('status', {}, { cancelReservation: true }))
        .then(result => {
          return result;
        })
        .catch(() => {
          return Map({ success: false });
        });
    },
    triggerEvent: () => {
      dispatch(actions.events.trigger('cancelled_booking'));
    }
  };
};

const mapStateToProps = store => {
  const reservation = store.getIn(['customer', 'reservation'],undefined);
  const hotelId = store.getIn(['customer', 'current_hotel'], undefined);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = store.getIn(['hotels', hotelId], undefined);

  const penalties = reservation.size > 0 && reservation.get('success') !== false && hotel && hotel.get('success') !== false &&
    getPenalties(
      reservation,
      store.getIn(['hotels', hotelId, 'management_group_id']) === PROPERTY_MANAGEMENT_GROUP,
      null,
      null,
      store.getIn(['hotels', hotelId, 'management_group_id']),
      getPenaltyTimezone(hotelInfo),
      getPenaltyChargebackUSA(hotelInfo)
    );

  return {
    hotelInfo: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
    params: store.getIn(['customer', 'params', 'params']),
    reservation: reservation,
    penalties: penalties,
    hotel: hotel,
    summaryPriceBreakdown: hotel && hotel.get('summary_price_breakdown', false),
  };
};



export default compose(
  validateAsyncComponent(mapStateToProps, [], LoadingReservation),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager(['params', 'reservation', 'cancelReservation', 'triggerEvent', 'penalties', 'hotel', 'hotelInfo', 'summaryPriceBreakdown']),
  withThemeJSS({ styleFile, link: true, index: 200 })
)(Cancelation);
